module.exports = __webpack_public_path__ + "img/successfulTemplate.036fecdc.png";